import { render, staticRenderFns } from "./MessageReply.vue?vue&type=template&id=2cc61d79&scoped=true"
import script from "./MessageReply.vue?vue&type=script&lang=js"
export * from "./MessageReply.vue?vue&type=script&lang=js"
import style0 from "./MessageReply.vue?vue&type=style&index=0&id=2cc61d79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc61d79",
  null
  
)

export default component.exports